/* eslint-disable */
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { EmptyMessage } from '../util/messages';
import { ColonnadeOnlineResourceService } from './colonnade-online-resource.service';
import { ClientDocumentResource } from '../client-document/client-document-resource.service';
import { ClientDocumentService } from '../client-document/client-document.service';
import { ClientDocument } from '../client-document/client-document.service';
import { ColonnadeOnlineResource } from './colonnade-online-resource.service';

/* eslint-enable */

@Injectable()
export class ColonnadeOnlineService implements ColonnadeOnline.Service {

  constructor(private resourceService: ColonnadeOnlineResourceService) {
  }

  offerLogin(documentType: string, request: ColonnadeOnline.OfferLoginRequest): Observable<ClientDocument.ClientDocument> {
    return Observable.create((observer: Observer<ClientDocument.ClientDocument>) => {
      return this.resourceService.offerLogin(documentType, this.toLoginRequestResource(request)).subscribe(
        (result: ClientDocumentResource.ClientDocument) => {
          observer.next(ClientDocumentService.toPublic(result));
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  offerAccept(documentType: string, request: ColonnadeOnline.OfferAcceptRequest): Observable<EmptyMessage> {
    return Observable.create((observer: Observer<EmptyMessage>) => {
      return this.resourceService.offerAccept(documentType, this.toAcceptRequestResource(request)).subscribe(
        (result: EmptyMessage) => {
          observer.next(result);
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  offerDecline(documentType: string, request: ColonnadeOnline.OfferDeclineRequest): Observable<EmptyMessage> {
    return Observable.create((observer: Observer<EmptyMessage>) => {
      return this.resourceService.offerDecline(documentType, this.toLoginRequestResource(request)).subscribe(
        (result: EmptyMessage) => {
          observer.next(result);
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  private toLoginRequestResource(request: ColonnadeOnline.OfferLoginRequest): ColonnadeOnlineResource.ClientDocumentOfferLoginRequestResource {
    return {
      password: request.password,
      token: request.token
    };
  }

  private toAcceptRequestResource(request: ColonnadeOnline.OfferAcceptRequest): ColonnadeOnlineResource.ClientDocumentOfferAcceptRequestResource {
    return {
      password: request.password,
      token: request.token,
      form: request.form ? this.toConsentFormResource(request.form) : undefined
    };
  }

  private toConsentFormResource(form: ColonnadeOnline.OfferConsentForm): ColonnadeOnlineResource.ClientDocumentOfferConsentFormResource {
    return {
      personal_information_provided: this.toConsentResource(form.personalInformationProvided),
      gathering_personal_information_approved: this.toConsentResource(form.gatheringPersonalInformationApproved),
      marketing_research_approved: this.toConsentResource(form.marketingResearchApproved),
      home_insurance_interested: this.toConsentResource(form.homeInsuranceInterested)
    };
  }

  private toConsentResource(consent?: ColonnadeOnline.OfferConsent): ColonnadeOnlineResource.ClientDocumentOfferConsentResource | undefined {
    if (!consent) {
      return undefined;
    }

    return {
      code: consent.code,
      text: consent.text
    };
  }

}

export namespace ColonnadeOnline {

  export const DOCUMENT_TYPE = 'colonnade_insurance_1';

  export interface Service {
    offerLogin(documentType: string, request: OfferLoginRequest): Observable<ClientDocument.ClientDocument>;
    offerAccept(documentType: string, request: OfferAcceptRequest): Observable<EmptyMessage>;
    offerDecline(documentType: string, request: OfferDeclineRequest): Observable<EmptyMessage>;
  }

  export interface OfferLoginRequest {
    password: string;
    token: string;
  }

  export interface OfferAcceptRequest extends OfferLoginRequest {
    form?: OfferConsentForm;
  }

  export interface OfferDeclineRequest extends OfferLoginRequest {
  }

  export interface OfferConsent {
    code?: string;
    text?: string;
  }

  export interface OfferConsentForm {
    personalInformationProvided?: OfferConsent;
    gatheringPersonalInformationApproved?: OfferConsent;
    marketingResearchApproved?: OfferConsent;
    homeInsuranceInterested?: OfferConsent;
  }
}

